const ClubInfoModalLogic = {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    componentName: 'ClubInfoModal',
  }),
  mounted() {
    window.addEventListener('club-info-modal:open', this.handleInfoModalOpen)
  },
  methods: {
    handleInfoModalClose() {
      this.closeAllDialogs()
    },
    handleInfoModalOpen() {
      this.openDialog(this.componentName)
    },
  },
}

export default ClubInfoModalLogic
